const POPUP_POLLING_INTERVAL = 500

export const nameSorter = ({ name: nameA }, { name: nameB }) => {
  const nameAToUpperCase = nameA.toUpperCase()
  const nameBToUpperCase = nameB.toUpperCase()
  if (nameAToUpperCase < nameBToUpperCase) {
    return -1
  } else if (nameAToUpperCase > nameBToUpperCase) {
    return 1
  }
  return 0
}

// Taken from https://stackoverflow.com/questions/3437786/get-the-size-of-the-screen-current-web-page-and-browser-window
export function PopupCenter({
  url,
  title,
  requestedWidth,
  requestedHeight,
  onClose,
}) {
  // Fixes dual-screen position                         Most browsers      Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY

  let width = window.innerWidth
  if (!window.innerWidth) {
    width = document.documentElement.clientWidth
  }
  if (!document.documentElement.clientWidth) {
    width = window.screen.width
  }
  let height = window.innerHeight
  if (!window.innerHeight) {
    height = document.documentElement.clientHeight
  }
  if (!document.documentElement.clientHeight) {
    height = window.screen.height
  }

  const left = width / 2 - requestedWidth / 2 + dualScreenLeft
  const top = height / 2 - requestedHeight / 2 + dualScreenTop
  const newWindow = window.open(
    url,
    title,
    `width=${requestedWidth}, height=${requestedHeight}, top=${top}, left=${left}`
  )

  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus()
  }

  if (onClose instanceof Function) {
    const timerHandle = setInterval(() => {
      if (newWindow.closed) {
        clearInterval(timerHandle)
        onClose()
      }
    }, POPUP_POLLING_INTERVAL)
  }

  return newWindow
}
